import { Link } from 'react-router'
import styled from 'styled-components'

import { APP_MARKET_PLACE, NEUTRAL_COLOURS } from 'constants/colors'

export const StyledContainer = styled(Link)`
  padding: 20px;
  border: 1px solid ${NEUTRAL_COLOURS.GRAY_TERTIARY};
  border-radius: 12px;
  cursor: pointer;
  min-width: 300px;
  color: ${NEUTRAL_COLOURS.BASIC};

  &:hover {
    background: ${NEUTRAL_COLOURS.GRAY_QUATERNARY};
    color: ${NEUTRAL_COLOURS.BASIC};
  }
`

export const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`

export const StyledLogo = styled.img`
  height: 48px;
  border-radius: 8px;
`

export const StyledChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-column-gap: 8px;
  grid-row-gap: 4px;
  justify-content: flex-end;
`

interface StyledChipProps {
  $alignRight?: boolean
  $backgroundColor?: string
  $color?: string
}

export const StyledChip = styled.div<StyledChipProps>`
  display: block;
  border-radius: 6px;
  padding: 4px 8px;
  width: max-content;
  ${({ $alignRight }) => $alignRight && 'justify-self: flex-end'};
  background-color: ${({ $backgroundColor }) => $backgroundColor || APP_MARKET_PLACE.CONNECTED};
  ${({ $color }) => $color && `color: ${$color};`}
`
